import { render, staticRenderFns } from "./LeaveChallenge.vue?vue&type=template&id=07b0a8a2&scoped=true&lang=pug&"
import script from "./LeaveChallenge.vue?vue&type=script&lang=js&"
export * from "./LeaveChallenge.vue?vue&type=script&lang=js&"
import style0 from "./LeaveChallenge.vue?vue&type=style&index=0&id=07b0a8a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b0a8a2",
  null
  
)

export default component.exports